/** Черновик документа (запись DocumentDrafts, контракт v2). */
export interface IDocumentDraft {
    /** uuid; генерирует фронт, живёт в адресе карточки. */
    id: string;
    /** Имя от пользователя; null — безымянный, показывается автозаголовок. */
    name: string | null;
    /** Тип документа (и ключевое поле, когда появится): считает фронт при сохранении. */
    autoTitle: string;
    /** Адрес карточки создания без идентификатора черновика. */
    url: string;
    actionId?: string | null;
    templateId?: string | null;
    baseDocId?: string | null;
    /** Версия данных для оптимистической блокировки (If-Match). */
    version: number;
    createdAt?: string | null;
    updatedAt?: string | null;
    /** Надгробие: id документа, в который превратился черновик. */
    consumedDocId?: string | null;
    /** Когда безымянный черновик удалит ретеншн (только в списке; у именованных нет). */
    expiresAt?: string | null;
}

/** Заголовок строки черновика: имя либо автозаголовок. */
export const draftDisplayTitle = (draft: Pick<IDocumentDraft, 'name' | 'autoTitle'>): string =>
    draft.name?.trim() || draft.autoTitle?.trim() || 'Черновик';
